"use strict";
/* eslint-disable no-param-reassign */
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const makeGroupBySingleFieldPointerMethod_1 = require("../makeGroupBySingleFieldPointerMethod");
exports.concentrationLimitPointerMethods = [
    (0, makeGroupBySingleFieldPointerMethod_1.makeGroupBySingleFieldPointerMethod)({
        field: 'community_name',
        method: 'sunboundCoromandel1.community',
        type: 'string',
        exclusion: {
            largestNumberOfGroups: 5,
        },
    }),
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map